<template>
  <div class="page">
    <el-form
      v-if="!show_but"
      :inline="true"
      :model="formInline"
      class="demo-form-inline"
    >
      <!--      <el-form-item label="审核状态">-->
      <!--        <el-select-->
      <!--          size="small"-->
      <!--          v-model="formInline.region"-->
      <!--          placeholder="审核状态"-->
      <!--        >-->
      <!--          <el-option label="未审核" value="shanghai"></el-option>-->
      <!--          <el-option label="已审核" value="beijing"></el-option>-->
      <!--          <el-option label="审核中" value="beijing1"></el-option>-->
      <!--        </el-select>-->
      <!--      </el-form-item>-->
      <el-form-item label="姓名">
        <el-input
          size="small"
          v-model="formInline.name"
          placeholder="申请人"
        ></el-input>
      </el-form-item>
      <el-form-item label="手机号">
        <el-input
          size="small"
          v-model="formInline.mobile"
          placeholder="申请人"
        ></el-input>
      </el-form-item>
      <!--      <el-form-item label="日期范围">-->
      <!--        <el-date-picker-->
      <!--          style="margin-right: 5px;width: 150px"-->
      <!--          size="small"-->
      <!--          v-model="formInline.start_time"-->
      <!--          type="date"-->
      <!--          placeholder="选择开始日期"-->
      <!--        >-->
      <!--        </el-date-picker>-->
      <!--        至-->
      <!--        <el-date-picker-->
      <!--          style="margin-left: 5px;width: 150px;"-->
      <!--          size="small"-->
      <!--          v-model="formInline.end_time"-->
      <!--          type="date"-->
      <!--          placeholder="选择结束日期"-->
      <!--        >-->
      <!--        </el-date-picker>-->
      <!--      </el-form-item>-->
      <el-form-item>
        <el-button size="small" type="primary" @click="getdataList"
          >查询</el-button
        >
      </el-form-item>
    </el-form>
    <div v-if="show_but" style="margin-bottom: 20px">
      <el-button
        size="small"
        type="primary"
        style="margin-right: 20px"
        @click="addClass"
        >新增车辆类目</el-button
      >
<!--      <el-select-->
<!--        size="small"-->
<!--        v-model="type"-->
<!--        placeholder="类型筛选"-->
<!--        clearable-->
<!--        @change="Secelt"-->
<!--      >-->
<!--        <el-option label="商用车" :value="1"></el-option>-->
<!--        <el-option label="非商用车" :value="2"></el-option>-->
<!--      </el-select>-->
    </div>
    <el-tabs @tab-click="tabScelect">
      <el-tab-pane label="审核管理">
        <el-table class="table" :data="tableData" border style="width: 100%">
          <el-table-column prop="name" label="姓名"> </el-table-column>
          <el-table-column prop="mobile" label="手机号"> </el-table-column>
          <el-table-column prop="car_type_name" label="专车类型">
          </el-table-column>
          <el-table-column prop="status" label="状态">
            <template slot-scope="scope">
              <el-tag
                v-text="
                  scope.row.status == 0
                    ? '待审核'
                    : scope.row.status == 1
                    ? '审核通过'
                    : '审核拒绝'
                "
                :type="
                  scope.row.status == 0
                    ? 'warning'
                    : scope.row.status == 1
                    ? 'success'
                    : 'danger'
                "
              ></el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="创建时间">
            <template slot-scope="scope">
              {{ scope.row.create_time | dataFormat }}
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                v-text="scope.row.status != 0 ? '详情' : '审核'"
                size="small"
                type="primary"
                @click="Audit(scope.row)"
                >审核</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="车辆类型">
        <el-table class="table" :data="tableData" border style="width: 100%">
          <el-table-column prop="url" label="图片" width="140" align="center">
            <template slot-scope="scope">
              <img width="100" height="50" :src="scope.row.url" />
            </template>
          </el-table-column>
          <el-table-column prop="name" label="名称"> </el-table-column>
<!--          <el-table-column prop="type" label="类型">-->
<!--            <template slot-scope="scope">-->
<!--              {{ scope.row.type == 1 ? "商用车" : "非商用车" }}-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column prop="type" label="会员级别">
            <template slot-scope="scope">
              <span>
                {{ scope.row.level_name }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态">
            <template slot-scope="scope">{{
              scope.row.status == 1 ? "开启" : "关闭"
            }}</template>
          </el-table-column>
          <el-table-column prop="create_time" label="创建时间">
            <template slot-scope="scope">
              {{ scope.row.create_time | dataFormat }}
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                size="small"
                type="primary"
                @click="edit_Type(scope.row)"
                >编辑</el-button
              >
              <el-button
                size="small"
                v-text="scope.row.status == 1 ? '关闭' : '开启'"
                @click="Isstatus(scope.row)"
              ></el-button>
              <el-button size="small" type="danger" @click="del_Type(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
    <el-pagination
      style="margin-top: 20px"
      background
      :page-size="10"
      layout="prev, pager, next"
      :total="total"
      @current-change="pagination"
      hide-on-single-page
    >
    </el-pagination>

    <el-dialog
      :title="Title"
      :visible.sync="ClassVisible"
      width="800px"
      :destroy-on-close="true"
    >
      <el-form :model="Classform" label-width="auto">
        <el-form-item label="类型名称">
          <el-input
            style="width: 45%;"
            v-model="Classform.name"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <!--        <el-form-item label="车辆分类">-->
        <!--          <el-radio-group v-model="Classform.type">-->
        <!--            <el-radio :label="1">商用车</el-radio>-->
        <!--            <el-radio :label="2">非商用车</el-radio>-->
        <!--          </el-radio-group>-->
        <!--        </el-form-item>-->
        <el-form-item label="会员级别" prop="level_ids">
          <el-select
            v-model="Classform.level_id"
            filterable
            collapse-tags
            placeholder="请选择"
          >
            <el-option-group
              v-for="group in vipList"
              :key="group.id"
              :label="group.name"
            >
              <el-option
                v-for="item in group.lists"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item label="图片">
          <el-upload
            action="#"
            ref="upload"
            :show-file-list="false"
            :http-request="
              file => {
                return upload_index_img(file);
              }
            "
            list-type="picture-card"
            :on-remove="handleRemove"
          >
            <el-progress
              v-if="ISprogressPercent"
              class="avatar"
              type="circle"
              :text-inside="true"
              :percentage="progressPercent"
            />
            <img
              v-if="Classform.url && !ISprogressPercent"
              class="avatar"
              :src="Classform.url"
            />
            <i
              v-if="!Classform.url && !ISprogressPercent"
              class="el-icon-plus"
            ></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="描述">
          <el-input
            style="width: 45%;"
            type="textarea"
            :autosize="{ minRows: 5 }"
            placeholder="请输入内容"
            v-model="Classform.desc"
          ></el-input>
        </el-form-item>
        <el-form-item label="类目状态">
          <el-switch
            v-model="Classform.status"
            active-text="开启"
            inactive-text="关闭"
            :active-value="1"
            :inactive-value="0"
          >
          </el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="ClassVisible = false">取 消</el-button>
        <el-button type="primary" @click="onSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { levelGroupSelect } from "@/api/vip";
import { TypeAddImage } from "@/api/mall";
import { mapGetters } from "vuex";
import { listAssign } from "@/utils/public";
import { addCarclass, CarRZlist, Carstatus, CarTypedel, CarTypedetail, CarTypelist, editCarclass } from "@/api/carRZ";

export default {
  computed: {
    ...mapGetters(["app_id"])
  },
  data() {
    return {
      ISprogressPercent: false,
      progressPercent: 0,
      total: 0,
      Title: "增加类目",
      progressFlag: false,
      tableData: [],
      show_but: false,
      ClassVisible: false,
      formInline: {
        name: "",
        mobile: ""
      },
      Classform: {
        name: "",
        url: "",
        desc: "",
        level_id: "",
        status: 0
      },
      vipList: [],
      page: 1,
      type: ""
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.get_levelGroupSelect();
      this.$nextTick(() => {
        this.getdataList();
      });
    },
    //跳转审核详情
    Audit(row) {
      this.$router.push({
        path: "Certification_info",
        query: {
          id: row.id
        }
      });
    },
    Secelt(val) {
      this.getdataList(this.show_but ? "车辆类型" : "审核管理");
    },
    tabScelect(tab) {
      this.show_but = tab.label == "车辆类型";
      this.$nextTick(() => {
        this.getdataList(tab.label);
      });
    },
    async getdataList(key) {
      let data = {
        app_id: this.app_id,
        page: this.page,
        num: 10
      };
      let res;
      if (key == "车辆类型") {
        data.type = this.type;
        res = await CarTypelist(data);
      } else {
        data.name = this.formInline.name;
        data.mobile = this.formInline.mobile;
        res = await CarRZlist(data);
      }
      this.tableData = res.data.result;
      this.total = res.data.total_num;
    },
    //翻页
    pagination(val) {
      this.page = val;
      if (this.show_but) {
        this.getdataList("车辆类型");
      } else {
        this.getdataList();
      }
    },
    addClass() {
      this.Title = "增加类目";
      this.Classform = {
        name: "",
        url: "",
        desc: "",
        type: "",
        level_ids: "",
        status: 0
      };
      this.ClassVisible = true;
    },
    //车类型
    async onSubmit() {
      this.Classform.app_id = this.app_id;
      let res;
      if (this.Title == "增加类目") {
        res = await addCarclass(this.Classform);
      } else {
        res = await editCarclass(this.Classform);
      }
      if (res.code == 200) {
        this.$message.success(res.msg);
        this.ClassVisible = false;
        this.getdataList("车辆类型");
      } else {
        this.$message.error(res.msg);
      }
    },
    //类型详情
    async detail(row) {
      const res = await CarTypedetail({ app_id: this.app_id, id: row.id });
    },
    //编辑类型
    edit_Type(row) {
      this.Title = "编辑类目";
      listAssign(this.Classform, row);
      this.Classform.level_id = Number(row.level_id);
      this.Classform.id = row.id;
      this.ClassVisible = true;
    },
    //类型状态
    async Isstatus(row) {
      let data = {
        app_id: this.app_id,
        id: row.id,
        status: row.status == 1 ? 0 : 1
      };
      const res = await Carstatus(data);
      if (res.code == 200) {
        this.$message.success(res.msg);
        this.getdataList("车辆类型");
      } else {
        this.$message.error(res.msg);
      }
    },
    //删除类型
    async del_Type(row) {
      const res = await CarTypedel({ app_id: this.app_id, id: row.id });
      if (res.code == 200) {
        this.$message.success(res.msg);
        this.getdataList("车辆类型");
      } else {
        this.$message.error(res.msg);
      }
    },
    //会员等级
    async get_levelGroupSelect() {
      const res = await levelGroupSelect({ app_id: this.app_id });
      if (res.code == 200) {
        this.vipList = res.data;
      }
    },
    //上传图片
    upload_index_img(file) {
      this.ISprogressPercent = true;
      console.log("wenjian", file.file);
      var formdata = new FormData();
      formdata.append("token", this.token);
      formdata.append("image", file.file);
      formdata.append("type", "1");
      formdata.append("file_group", "1");
      const uploadProgressEvent = progressEvent => {
        this.progressPercent = Math.floor(
          (progressEvent.loaded * 100) / progressEvent.total
        );
      };
      TypeAddImage(formdata, uploadProgressEvent).then(res => {
        if (res.code == 200) {
          console.log("tu", res);
          this.Classform.url = res.data.url;
          if (this.progressPercent == 100) {
            this.ISprogressPercent = false;
            this.progressPercent = 0;
          }
        } else {
          this.$message.warning(res.msg + "(" + res.data + ")");
        }
      });
    },
    //删除图片
    handleRemove(file, fileList) {
      console.log(file, fileList);
      console.log("删除", file);
      this.Classform.url = "";
    },
    beforeAvatarUpload(event, file, fileList) {
      console.log("进度", event);
      let loadProgress = Math.floor(event.percent); //这就是当前上传的进度

      //可以进行其他逻辑
    }
  }
};
</script>
<style lang="scss" scoped>
.page {
  padding: 30px;
  .table {
    margin-top: 20px;
  }
}
.avatar-uploader .el-upload {
  border: 1px dashed #000;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
}
.avatar {
  width: 100%;
  height: 100%;
  display: block;
}
.content .upload-demo ::v-deep .el-upload–text {
  border: 1px solid black;
}
</style>
